<dialog-draggable-header>Add Span</dialog-draggable-header>

    <mat-dialog-content class="add-modal-content">
    <form class="container" [formGroup]="this.form">
        <div class="row">
            <mat-form-field class="col" floatLabel="always">
                <input formControlName="span" matInput placeholder="Span" min="0" maxlength="50"
                    oninput="this.value = this.value.toUpperCase()" />
            </mat-form-field>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="conceptWeeks" matInput type="number" placeholder="Concept Weeks"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" floatLabel="always">
                <input formControlName="mathUnits" matInput placeholder="Math Units" min="0" maxlength="10" />
            </mat-form-field>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="designWeeks" matInput type="number" placeholder="Design Weeks"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" floatLabel="always">
                <input formControlName="examples1" matInput placeholder="Examples of Fixture Types with No Undercut"
                    min="0" maxlength="150" />
            </mat-form-field>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="buildWeeks" matInput type="number" placeholder="Build Weeks"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" floatLabel="always">
                <input formControlName="examples2" matInput placeholder="Examples of Fixture Types with Undercut"
                    min="0" maxlength="150" />
            </mat-form-field>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="conceptBuffer" matInput type="number" placeholder="Concept Buffer"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col" floatLabel="always">
                <input formControlName="examples3" matInput placeholder="Examples of Fixture Types with Cheek Rails"
                    min="0" maxlength="150" />
            </mat-form-field>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="designBuffer" matInput type="number" placeholder="Design Buffer"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-checkbox formControlName="active" class="d-inline checkbox-format col my-auto ml-1" color="primary"
                disableRipple>
                Active?
            </mat-checkbox>
            <mat-form-field class="col-4" floatLabel="always">
                <input formControlName="buildBuffer" matInput type="number" placeholder="Build Buffer"
                    matTooltip="Valid range is between -100 and 100" />
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
    <mat-dialog-actions class="mat-dialog-actions-end no-margin">
        <span class="cgp-flex-fill"></span>
        <button color="primary" mat-raised-button (click)="onSaveClick()"
            [disabled]="this.loading || !this.form.valid">Save</button>
        <button mat-raised-button mat-dialog-close [disabled]="this.loading">Cancel</button>
   
</mat-dialog-actions>
